import React from "react";
import {NavLink, useRouteMatch} from "react-router-dom";
import {useTranslation} from "react-i18next";

const SettingsMenu = () => {
    let match = useRouteMatch();
    const {t} = useTranslation();

    return (
        <div className="col-12 col-md-3">
            <div className="card card-custom gutter-b shadow">
                <div className="card-body">
                    <div className="d-flex flex-column border-bottom border-gray gutter-b">
                        <h6 className="font-weight-bold text-uppercase mb-3">{t("ADMINPANEL.MENU.TITLE")}</h6>
                        <div className="nav flex-column nav-pills py-3">
                            <NavLink
                                to={`${match.path}/`}
                                exact
                                className="nav-link settings_menu_listItems"
                                activeClassName="active"
                            >
                                {t("ADMINPANEL.MENU.GENERAL")}
                            </NavLink>
                            <NavLink
                                to={`${match.path}/loginpage`}
                                exact
                                className="nav-link settings_menu_listItems"
                                activeClassName="active"
                            >
                                {t("ADMINPANEL.MENU.LOGIN_PAGE")}
                            </NavLink>
                            <NavLink
                                to={`${match.path}/homepage`}
                                exact
                                className="nav-link settings_menu_listItems"
                                activeClassName="active"
                            >
                                {t("ADMINPANEL.MENU.HOME_PAGE")}
                            </NavLink>
                            <NavLink
                                to={`${match.path}/icons`}
                                exact
                                className="nav-link settings_menu_listItems"
                                activeClassName="active"
                            >
                                {t("ADMINPANEL.MENU.ICONS")}
                            </NavLink>
                        </div>
                    </div>
                    <div className="d-flex flex-column border-bottom border-gray gutter-b">
                        <h6 className="font-weight-bold text-uppercase mb-3">
                            {t("ADMINPANEL.MENU.SUBTITLE.CONTENT")}
                        </h6>
                        <div className="nav flex-column nav-pills py-3">
                            <NavLink
                                to={`${match.path}/media_items`}
                                exact
                                className="nav-link settings_menu_listItems"
                                activeClassName="active"
                            >
                                {t("ADMINPANEL.MENU.MEDIA_ITEMS")}
                            </NavLink>
                            <NavLink
                                to={`${match.path}/tracks`}
                                exact
                                className="nav-link settings_menu_listItems"
                                activeClassName="active"
                            >
                                {t("ADMINPANEL.MENU.TRACKS")}
                            </NavLink>
                            <NavLink
                                to={`${match.path}/upload`}
                                exact
                                className="nav-link settings_menu_listItems"
                                activeClassName="active"
                            >
                                {t("ADMINPANEL.MENU.UPLOAD")}
                            </NavLink>
                        </div>
                    </div>
                    <div className="d-flex flex-column border-bottom border-gray gutter-b">
                        <h6 className="font-weight-bold text-uppercase mb-3">
                            {t("ADMINPANEL.MENU.SUBTITLE.ANALYTICS")}
                        </h6>
                        <div className="nav flex-column nav-pills py-3">
                            <NavLink
                                to={`${match.path}/contentaudit`}
                                exact
                                className="nav-link settings_menu_listItems"
                                activeClassName="active"
                            >
                                {t("ADMINPANEL.MENU.CONTENT_AUDIT")}
                            </NavLink>
                            <NavLink
                                to={`${match.path}/userbehaviour`}
                                exact
                                className="nav-link settings_menu_listItems"
                                activeClassName="active"
                            >
                                {t("ADMINPANEL.MENU.USER_BEHAVIOR")}
                            </NavLink>
                        </div>
                    </div>

                    <div className="d-flex flex-column border-bottom border-gray gutter-b">
                        <h6 className="font-weight-bold text-uppercase mb-3">
                            {t("ADMINPANEL.MENU.SUBTITLE.BILLING")}
                        </h6>
                        <div className="nav flex-column nav-pills py-3">
                            <NavLink
                                to={`${match.path}/users`}
                                className="nav-link settings_menu_listItems"
                                activeClassName="active"
                            >
                                {t("ADMINPANEL.MENU.USERS")}
                            </NavLink>
                            <NavLink
                                to={`${match.path}/plans`}
                                exact
                                className="nav-link settings_menu_listItems"
                                activeClassName="active"
                            >
                                {t("ADMINPANEL.MENU.PLANS_PAYMENTS")}
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingsMenu;
